import {
  FaCar,
  FaUsers,
  FaClipboardList,
  FaHistory,
  FaBalanceScaleRight,
  FaFileAlt,
} from "react-icons/fa";
import { IoIosPricetags } from "react-icons/io";
import { VscGitPullRequestNewChanges } from "react-icons/vsc";
import { BsCurrencyExchange } from "react-icons/bs";
import { MdOutlineDomainVerification } from "react-icons/md";

export const menuItems = [
  {
    name: "Passenger List",
    path: "/home",
    icon: <FaUsers className="text-xl" />,
  },
  {
    name: "Driver List",
    path: "/alldriver",
    icon: <FaClipboardList className="text-xl" />,
  },
  {
    name: "Active Rides",
    path: "/activeRides",
    icon: <FaCar className="text-xl" />,
  },
  {
    name: "Document Verification",
    path: "/documentVerification",
    icon: <MdOutlineDomainVerification className="text-xl" />,
  },
  {
    name: "Ride History",
    path: "/rideHistory",
    icon: <FaHistory className="text-xl" />,
  },
  {
    name: "My Income",
    path: "/income",
    icon: <BsCurrencyExchange className="text-xl" />,
  },
  {
    name: "Price Surge",
    path: "/priceSurge",
    icon: <IoIosPricetags className="text-xl" />,
  },
  // {
  //   name: "Outstanding Balance",
  //   path: "/outstandingBalance",
  //   icon: <FaBalanceScaleRight className="text-xl" />,
  // },
  {
    name: "Instant Request",
    path: "/instantRequest",
    icon: <VscGitPullRequestNewChanges className="text-xl" />,
  },
  {
    name: "Customer Support",
    path: "/refundRequest",
    icon: <FaClipboardList className="text-xl" />,
  },
];

